/**
 * Online demo module catalog (demo.qawaem.live) — 27 modules aligned with moduleStructure.
 * Display names/descriptions: onlineDemo.modules.{KEY}.name|description in locales/ar/translation.json
 */

export const ALL_MODULES = [
  { key: 'ARTICLE', icon: 'Boxes', color: '#6366F1', category: 'commercial' },
  { key: 'INVENTAIRE', icon: 'PackageCheck', color: '#8B5CF6', category: 'commercial' },
  { key: 'FACTURATION', icon: 'Receipt', color: '#3B82F6', category: 'commercial' },
  { key: 'CRM', icon: 'Users', color: '#06B6D4', category: 'commercial' },
  { key: 'RELATION_FOURNISSEUR', icon: 'Building2', color: '#F97316', category: 'commercial' },
  { key: 'ACHATS', icon: 'ShoppingBasket', color: '#F59E0B', category: 'commercial' },
  { key: 'VENTES', icon: 'TrendingUp', color: '#10B981', category: 'commercial' },
  { key: 'RESSOURCES_HUMAINES', icon: 'UserCog', color: '#8B5CF6', category: 'rh' },
  { key: 'POINTAGE', icon: 'Clock', color: '#0EA5E9', category: 'rh' },
  { key: 'SALAIRES', icon: 'DollarSign', color: '#22C55E', category: 'rh' },
  { key: 'CAISSE', icon: 'Vault', color: '#10B981', category: 'commercial' },
  { key: 'BANQUE', icon: 'Landmark', color: '#3B82F6', category: 'finance' },
  { key: 'COMPTABILITE', icon: 'Calculator', color: '#8B5CF6', category: 'finance' },
  { key: 'TRESORERIE', icon: 'Wallet', color: '#F59E0B', category: 'finance' },
  { key: 'BUDGET', icon: 'PieChart', color: '#EC4899', category: 'finance' },
  { key: 'PROJETS', icon: 'ClipboardList', color: '#84CC16', category: 'workflow' },
  { key: 'CONTRATS', icon: 'FileSignature', color: '#6366F1', category: 'workflow' },
  { key: 'PARC_AUTO', icon: 'Car', color: '#EC4899', category: 'logistique' },
  { key: 'LOGISTIQUE', icon: 'Truck', color: '#F59E0B', category: 'logistique' },
  { key: 'DISTRIBUTION', icon: 'Store', color: '#3B82F6', category: 'logistique' },
  { key: 'LIVRAISON', icon: 'PackageCheck', color: '#22C55E', category: 'logistique' },
  { key: 'MARKETING', icon: 'Megaphone', color: '#F97316', category: 'commercial' },
  { key: 'TACHES', icon: 'CheckSquare', color: '#8B5CF6', category: 'workflow' },
  { key: 'SERVICE_CLIENT', icon: 'Headphones', color: '#06B6D4', category: 'commercial' },
  { key: 'APPROBATIONS', icon: 'CheckCircle', color: '#10B981', category: 'workflow' },
  { key: 'PLANIFICATION', icon: 'CalendarCheck', color: '#3B82F6', category: 'workflow' },
  { key: 'GESTION_SITUATION', icon: 'AlertTriangle', color: '#DC2626', category: 'workflow' },
];
